// モーダルに関する機能を提供する
import scrollPreventor from './scroll_preventor';

export const modalOpen = (modal) => {
  modal.classList.add('active');
  scrollPreventor(true);
};

export const modalClose = (modal) => {
  modal.classList.remove('active');
  scrollPreventor(false);
};

const modalToggle = (modal) => {
  if (modal.classList.contains('active'))
    modalClose(modal);
  else
    modalOpen(modal);
};

export default modalToggle;
